import React, { Component } from "react";
import { connect } from "react-redux";
import { css } from "aphrodite";
import CardSupport from "../../components/dasboard/CardSupport";
import CardDanaEstimasi from
  "../../components/dasboard/CardDanaEstimasi";
import CardDanaPusat from "../../components/dasboard/CardDanaPusat";
import CardDanaMasuk from "../../components/dasboard/CardDanaMasuk";
import CardMemberPusat from
  "../../components/dasboard/CardMemberPusat";
import CardKoperasi from
  "../../components/dasboard/CardKoperasiPusat";
import CardMaps from "../../components/dasboard/CardMapsKolegium";
import { listBranch } from
  "../../actions/master-data/branch_action";
import { getDashboardData } from
  "../../reducers/dashboard/kolegium_reducer";
import { dashboardGridStyles as s } from
  "../../components/dasboard/dashboardGridStyles";

class DashboardAdminPusat extends Component {
  componentDidMount() {
    this.props.listBranch({ length: 999 });
  }

  render() {
    return (
      <>
        <div className={css(s.row)}>
          <div className={css(s.col75)}>
            <div style={{ marginBottom: 20 }}>
              <CardMaps />
            </div>
            <CardKoperasi />
          </div>
          <div className={css(s.col25)}>
            <div style={{ marginBottom: 40 }}>
              <CardMemberPusat />
            </div>
            <CardSupport />
          </div>
        </div>
        <div className={css(s.row)}>
          <div className={css(s.col33)}>
            <CardDanaEstimasi />
          </div>
          <div className={css(s.col33)}>
            <CardDanaMasuk />
          </div>
          <div className={css(s.col33)}>
            <CardDanaPusat />
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({
  listCandidate,
  listGraduated,
  listOrthopaedi,
}) {
  return {
    listCandidate_data: getDashboardData(listCandidate),
    listGraduated_data: getDashboardData(listGraduated),
    listOrthopaedi_data: getDashboardData(listOrthopaedi),
  };
}

export default connect(mapStateToProps, {
  listBranch,
})(DashboardAdminPusat);
